module.exports = __webpack_public_path__ + "img/completeInfo.b269d06f.png";